import React from 'react';

interface ESGLedgerLogoProps {
  className?: string;
  /** `dark` = white/inverted logo for dark backgrounds */
  variant?: 'light' | 'dark' | 'transparent';
  /** Scale up visually inside a fixed layout slot (does not shift siblings). */
  enlarged?: boolean;
}

const LOGO_ASPECT = 2; // source image is ~2:1
const ENLARGED_SCALE_X = 1.85;
const ENLARGED_SCALE_Y = 1.75;

export const ESGLedgerLogo: React.FC<ESGLedgerLogoProps> = ({
  className = 'h-10',
  variant = 'light',
  enlarged = false,
}) => {
  // Pure white logo on dark surfaces (keeps alpha, flattens brand colors)
  const invertClass = variant === 'dark' ? 'brightness-0 invert' : '';

  if (!enlarged) {
    return (
      <img
        src="/esg-ledger-logo.png"
        alt="ESGLedger — Powered by ONE CHAIN"
        className={`w-auto object-contain shrink-0 ${invertClass} ${className}`}
      />
    );
  }

  // Reserve layout width for the scaled image so siblings are not overlapped.
  const slotAspect = LOGO_ASPECT * ENLARGED_SCALE_X;

  return (
    <span
      className={`relative inline-block shrink-0 overflow-visible ${className}`}
      style={{ aspectRatio: `${slotAspect} / 1` }}
    >
      <img
        src="/esg-ledger-logo.png"
        alt="ESGLedger — Powered by ONE CHAIN"
        className={`absolute left-0 top-1/2 h-full w-auto max-w-none object-contain pointer-events-none ${invertClass}`}
        style={{
          transformOrigin: 'left center',
          transform: `translateY(-50%) scaleX(${ENLARGED_SCALE_X}) scaleY(${ENLARGED_SCALE_Y})`,
        }}
      />
    </span>
  );
};
